import * as React from "react";
import { useHistory } from "react-router-dom";
import { ListActionButtonProps } from "sprint-common-web";

import { tvSeriesAssetsListRoute } from "../../../../assets/AssetsRoutes";
import { ViewAssetButton } from "../../../common/components/ViewAssetButton";

export const ViewTvSeriesAssetButton: React.FunctionComponent<ListActionButtonProps> = (
    props: ListActionButtonProps
) => {
    const history = useHistory();
    const handleClick = () => {
        if (props.itemId) moveToTvSeriesAssets(props.itemId);
    };

    const moveToTvSeriesAssets = (tvSeriesId: string) => {
        const basePath = tvSeriesAssetsListRoute.path;
        const requiredPath = basePath?.slice(0, basePath.lastIndexOf("/"));
        history.push(`${requiredPath}/${tvSeriesId}`);
    };

    return <ViewAssetButton disabled={props.disabled} onClick={handleClick} />;
};
